import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { SettingsProvider } from './contexts/SettingsContext';
import 'leaflet/dist/leaflet.css';

// Log environment information
console.log('Environment:', import.meta.env.MODE);
console.log('Base URL:', import.meta.env.VITE_APP_BASE_URL);

ReactDOM.createRoot(document.getElementById('root')).render(
  <SettingsProvider>
    <App />
  </SettingsProvider>
);
